import React from "react";
import "./MediaPage.scss";
import { TitleComponent } from "../../components/TitleDocument";
import BreadCrumb from "../../components/BreadCrumb";
import Album from "../../components/Video/Album";
import newsBackground from "../../assets/news_bg.svg";

const MEDIA_ALBUM_COPY = {
  title: "Thư viện hình ảnh",
  description:
    "Khám phá thư viện hình ảnh ghi lại những dấu ấn nổi bật trong các hoạt động, sự kiện và hệ sinh thái hạ tầng số của VNPT Net, thể hiện quy mô, năng lực và định hướng phát triển trong từng giai đoạn.",
};

const MediaAlbum = () => {
  return (
    <section className="video_media_page video_media_page--album">
      <TitleComponent title="Thu-vien-hinh-anh" />

      <div className="video_media_page__shell">
        <div className="video_media_page__crumb container">
          <BreadCrumb caseCondition="case1" />
        </div>

        <div className="video_media_page__layout container">
          <main className="video_media_page__main">
            <div className="video_media_page__stage">
              <div
                className="video_media_page__bg"
                style={{ backgroundImage: `url(${newsBackground})` }}
                aria-hidden="true"
              />

              <section className="video_media_page__intro">
                <div className="video_media_page__intro-inner">
                  <h1>{MEDIA_ALBUM_COPY.title}</h1>
                  <p>{MEDIA_ALBUM_COPY.description}</p>
                </div>
              </section>

              <Album />
            </div>
          </main>
        </div>
      </div>
    </section>
  );
};

export default MediaAlbum;
